export const householdInformationStrings = {
  strings: {
    en: {
      householdInformationHeading: 'Household Information',
      sectionDescription: 'Please list the number of people within your household.',
      adults: 'Adults',
      childredn: 'Children',
      noOfAdults: 'Number of Adults',
      noOfChildren: 'Number of Children',
      total: 'Total Household Members: ',
      errorMessage: 'Number of adults cannot be zero.',
      emptyErrorMessage: 'Please enter number of adults.'
    },
    zh: {
      householdInformationHeading: '家庭信息',
      sectionDescription: '請列出您家中的人數。',
      adults: '成人',
      childredn: '孩子',
      noOfAdults: '成人人數',
      noOfChildren: '兒童人數',
      total: '家庭成員總數：',
      errorMessage: 'Number of adults cannot be zero.',
      emptyErrorMessage: 'Please enter number of adults.'
    },
    es: {
      householdInformationHeading: 'Información sobre el hogar',
      sectionDescription: 'Ingresa el número de personas que viven en tu hogar.',
      adults: 'Adultos',
      childredn: 'Niños',
      noOfAdults: 'Por favor ingrese el número de adultos',
      noOfChildren: 'Por favor ingrese el número de niños',
      total: 'Total de integrantes del hogar: ',
      errorMessage: 'Number of adults cannot be zero.',
      emptyErrorMessage: 'Please enter number of adults.'
    },
    ko: {
      householdInformationHeading: '확인 및 제출',
      sectionDescription: '귀하 가구의 수를 기입하십시오.',
      adults: '성인',
      childredn: '어린이',
      noOfAdults: '성인 수',
      noOfChildren: '자녀의 수',
      total: '총 가구원',
      errorMessage: 'Number of adults cannot be zero.',
      emptyErrorMessage: 'Please enter number of adults.'
    },
    vi: {
      householdInformationHeading: 'Xác nhận và gửi',
      sectionDescription: 'Vui lòng liệt kê số người trong gia đình bạn',
      adults: 'Người lớn',
      childredn: 'Bọn trẻ',
      noOfAdults: 'Số lượng người lớn',
      noOfChildren: 'Số lượng trẻ em',
      total: 'Tổng số thành viên hộ gia đình',
      errorMessage: 'Number of adults cannot be zero.',
      emptyErrorMessage: 'Please enter number of adults.'
    }
  },

  common: []
};